export interface Volume {
  number: string;
  title: string;
  subtitle: string;
  body: { text: string; bold?: boolean }[];
  promise: string;
  featured?: boolean;
}

export const volumes: Volume[] = [
  {
    number: 'VOL. 01',
    title: 'Licensing, Compliance & Inspection Readiness',
    subtitle: 'Pass every visit without the week of panic.',
    body: [
      { text: 'Inside: ' },
      { text: 'The Licensing Requirements Matrix', bold: true },
      { text: ', ' },
      { text: 'The Inspection-Day Walkthrough', bold: true },
      { text: ', ' },
      { text: 'The Corrective Action Playbook', bold: true },
      { text: ' and ' },
      { text: 'The Records Retention Calendar', bold: true },
      {
        text: '. Every document a licensor asks for, filed in the order they ask for it, with the follow-up letters already written.',
      },
    ],
    promise: '→ You are never caught unprepared by an unannounced visit again.',
  },
  {
    number: 'VOL. 02',
    title: 'Policies, Contracts & Tuition That Actually Gets Paid',
    subtitle: 'The document set that ends the awkward conversation about money.',
    body: [
      { text: 'Inside: ' },
      { text: 'The Master Enrollment Agreement', bold: true },
      { text: ', ' },
      { text: 'The Late-Payment Ladder', bold: true },
      { text: ', ' },
      { text: 'The Holiday, Sick-Day & Vacation Policy Grid', bold: true },
      { text: ' and ' },
      { text: 'The Withdrawal & Termination Notice Set', bold: true },
      {
        text: '. Written in plain English, signed at enrollment, so the rule is the rule before it is ever tested.',
      },
    ],
    promise:
      '→ Every dollar you are owed is written down, agreed to, and collected on schedule.',
    featured: true,
  },
  {
    number: 'VOL. 03',
    title: 'Enrollment, Waitlists & Local Demand',
    subtitle: 'How to stay full without discounting your rate.',
    body: [
      { text: 'Inside: ' },
      { text: 'The Tour Script', bold: true },
      { text: ', ' },
      { text: 'The Waitlist Ledger', bold: true },
      { text: ', ' },
      { text: 'The Referral Loop', bold: true },
      { text: ' and ' },
      { text: 'The Local Listings Setup Sheet', bold: true },
      {
        text: '. The exact sequence that turns an inquiry into a signed agreement and a deposit, in one visit.',
      },
    ],
    promise:
      '→ A waitlist deep enough that one family leaving stops being an emergency.',
  },
  {
    number: 'VOL. 04',
    title: 'Daily Operations, Ratios & Staffing',
    subtitle: 'The system that runs when you are not in the room.',
    body: [
      { text: 'Inside: ' },
      { text: 'The Ratio & Group-Size Calculator', bold: true },
      { text: ', ' },
      { text: 'The Daily Rhythm Sheets', bold: true },
      { text: ', ' },
      { text: 'The Substitute Binder', bold: true },
      { text: ' and ' },
      { text: 'The 30-Day Staff Onboarding Track', bold: true },
      {
        text: '. Opening to closing, written down once, so a new hire or a fill-in can follow it without calling you.',
      },
    ],
    promise: '→ A day that runs on the schedule instead of on your memory.',
  },
  {
    number: 'VOL. 05',
    title: 'Health, Safety & Emergency Protocols',
    subtitle: 'Written procedures for the moments you cannot improvise.',
    body: [
      { text: 'Inside: ' },
      { text: 'The Illness Exclusion Chart', bold: true },
      { text: ', ' },
      { text: 'The Medication & Allergy Logs', bold: true },
      { text: ', ' },
      { text: 'The Emergency Action Cards', bold: true },
      { text: ' and ' },
      { text: 'The Incident Report Set', bold: true },
      {
        text: '. Posted, laminated, and consistent — so two different adults handle the same situation the same way.',
      },
    ],
    promise:
      '→ Documented, defensible answers before a parent ever has to ask the question.',
  },
  {
    number: 'VOL. 06',
    title: 'Money, Taxes & Sustainable Growth',
    subtitle: 'Your program treated like a business with a margin.',
    body: [
      { text: 'Inside: ' },
      { text: 'The Rate-Setting Worksheet', bold: true },
      { text: ', ' },
      { text: 'The Time-Space Percentage Tracker', bold: true },
      { text: ', ' },
      { text: 'The Deduction Master List', bold: true },
      { text: ' and ' },
      { text: 'The Rate Increase Announcement Sequence', bold: true },
      {
        text: '. What to charge, what to write off, and how to raise a rate without losing the family.',
      },
    ],
    promise:
      '→ Rates that reflect the work, and records your accountant will thank you for.',
  },
];

export const startHere = {
  label: 'START HERE',
  title: 'Open Volume 2 first.',
  body:
    'Most providers do not have a policy problem — they have an unwritten policy problem. Print the Master Enrollment Agreement and the Late-Payment Ladder, put them in front of your families this week, and the system pays for itself before you finish Volume 3. [Vol. 2 · p. __]',
};

export const insideEveryVolume = {
  title: 'Inside every volume',
  items: [
    'Printable checklists you can hang on the wall, not just read once.',
    'Fill-in-the-blank templates — your name, your rates, your state, done in an afternoon.',
    'State-by-state notes flagging where requirements commonly differ.',
    'A one-page summary at the front of each volume for the days you have four minutes.',
    'Plain-English language you can hand directly to a parent without translating it.',
  ],
};

export const coverage = [
  'Licensing & compliance',
  'Contracts & tuition',
  'Enrollment & marketing',
  'Ratios & staffing',
  'Health & safety',
  'Taxes & rate-setting',
];

export const productStats = [
  { value: '6', label: 'Volumes' },
  { value: '412', label: 'Pages' },
  { value: '61', label: 'Templates' },
  { value: '14', label: 'Wall checklists' },
];
